module.exports = __webpack_public_path__ + "img/ee.285993dc.svg";